import { Layout } from 'react-admin';

import MgaAppBar from './MgaAppBar';
import MgaMenu from './MgaMenu';

export function PumpkinLayout(props) {
  return (
    <Layout {...props} appBar={MgaAppBar} menu={MgaMenu} sx={{ padding: '8px' }} />
  );
}
